"use strict";

exports.__esModule = true;
exports.toString = exports.supportsDataView = exports.supportsArrayBuffer = exports.slice = exports.root = exports.push = exports.nonEnumerableProps = exports.nativeKeys = exports.nativeIsView = exports.nativeIsArray = exports.nativeCreate = exports.hasOwnProperty = exports.hasEnumBug = exports._isNaN = exports._isFinite = exports.VERSION = exports.SymbolProto = exports.ObjProto = exports.MAX_ARRAY_INDEX = exports.ArrayProto = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// Current version.
var VERSION = exports.VERSION = '1.13.7';

// Establish the root object, `window` (`self`) in the browser, `global`
// on the server, or `this` in some virtual machines. We use `self`
// instead of `window` for `WebWorker` support.
var root = exports.root = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self.self === self && self || (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global.global === global && global || Function('return this')() || {};

// Save bytes in the minified (but not gzipped) version:
var ArrayProto = exports.ArrayProto = Array.prototype,
  ObjProto = exports.ObjProto = Object.prototype;
var SymbolProto = exports.SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

// Create quick reference variables for speed access to core prototypes.
var push = exports.push = ArrayProto.push,
  slice = exports.slice = ArrayProto.slice,
  toString = exports.toString = ObjProto.toString,
  hasOwnProperty = exports.hasOwnProperty = ObjProto.hasOwnProperty;

// Modern feature detection.
var supportsArrayBuffer = exports.supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
  supportsDataView = exports.supportsDataView = typeof DataView !== 'undefined';

// All **ECMAScript 5+** native function implementations that we hope to use
// are declared here.
var nativeIsArray = exports.nativeIsArray = Array.isArray,
  nativeKeys = exports.nativeKeys = Object.keys,
  nativeCreate = exports.nativeCreate = Object.create,
  nativeIsView = exports.nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

// Create references to these builtin functions because we override them.
var _isNaN = exports._isNaN = isNaN,
  _isFinite = exports._isFinite = isFinite;

// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug = exports.hasEnumBug = !{
  toString: null
}.propertyIsEnumerable('toString');
var nonEnumerableProps = exports.nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

// The largest integer that can be represented exactly.
var MAX_ARRAY_INDEX = exports.MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;